import {cameraSvg as Icon__small__cameraSvg} from '../Icon__small/Icon__small--camera.js';

export var camera = {
  name: 'camera',
  category: 'icon',
  colorable: true,
  svg: Icon__small__cameraSvg,
};
